import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Tooltip } from '../../../../common/tooltip'
import { EMPTY_VALUE } from '../../../../utils/common'
import { VALUE_SCORE } from '../../constant'

export const CellData = ({ data, isDynamicReport, typeValue }) => {
  return (
    <div className="textCenter">
      <Tooltip tooltipContent="portfolioScore.median" isI18n>
        <Element className="fw600" style={{ paddingBottom: 1 }}>
          {formatNumber(data?.medianValue, typeValue)}
        </Element>
      </Tooltip>
      {!isDynamicReport && (
        <Tooltip
          tooltipContent={
            <>
              <div className="dFlex">
                <Translate value="portfolioScore.firstQuartile" />
                &ensp;|&ensp;
                <Translate value="portfolioScore.thirdQuartile" />
              </div>
            </>
          }
        >
          <Element className="dFlex justifyContentCenter alignItemsCenter">
            <div className="textEnd">
              {formatNumber(data?.quartile1, typeValue)}
            </div>
            <div
              style={{
                textAlign: 'left',
                borderLeft: '1px solid #9C9C9C',
                paddingLeft: 8,
                marginLeft: 8,
              }}
            >
              {formatNumber(data?.quartile3, typeValue)}
            </div>
          </Element>
        </Tooltip>
      )}
    </div>
  )
}

export const formatNumber = (number, typeValue) => {
  if (!number) {
    if (
      typeValue === VALUE_SCORE.CREDIT_SCORE &&
      (number === '0' || number === 0)
    ) {
      return 0
    }
    return EMPTY_VALUE
  }
  if (('' + number).split('').includes('.')) {
    return ('' + number).replace('.', ',')
  }
  return number
}
